import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

// リサイズ時のクローン数更新処理
const updateClonesOnResize = (slider, itemWidth) => {
  slider.on('resize', () => {
    const windowWidth = window.innerWidth;
    const perPage = Math.floor(windowWidth / itemWidth) + 1;
    slider.options = { clones: perPage };
  });
};

// カテゴリースライダーのセットアップ
const setupCategorySlider = () => {
  const categorySlider = document.querySelector('.js-categorySlider');
  if (!categorySlider) return;

  const item = document.querySelector('.js-categorySliderGroup');
  const itemWidth = item.offsetWidth;
  const windowWidth = window.innerWidth;
  const perPage = Math.floor(windowWidth / itemWidth) + 1;

  const splideInstance = new Splide(categorySlider, {
    type: 'loop',
    drag: false,
    arrows: false,
    gap: 30,
    clones: perPage,
    pagination: false,
    autoWidth: true,
    autoScroll: {
      speed: 0.25,
    },
  });

  updateClonesOnResize(splideInstance, itemWidth);

  splideInstance.mount({ AutoScroll });
};

// 特集記事スライダーのセットアップ
const setupFirstViewSlider = () => {
  const firstViewSlider = document.querySelector('.js-firstViewSlider');
  if (!firstViewSlider) return;

  const splideInstance = new Splide(firstViewSlider, {
    type: 'slide',
    pagination: false,
    arrows: false,
    gap: 20,
    autoWidth: true,
  });

  splideInstance.mount();
};

// キーワードスライダーのセットアップ
const setupKeywordSliders = () => {
  const keywordSliders = document.querySelectorAll('.js-keywordsSlider');
  if (!keywordSliders) return;

  keywordSliders.forEach((slider, index) => {
    const item = slider.querySelector('.js-keywordsSliderGroup');
    const itemWidth = item.offsetWidth;
    const windowWidth = window.innerWidth;
    const speed = index % 2 === 0 ? 0.25 : -0.25;
    const perPage = Math.floor(windowWidth / itemWidth) + 1;

    const splideInstance = new Splide(slider, {
      type: 'loop',
      drag: false,
      clones: perPage,
      gap: 6,
      arrows: false,
      pagination: false,
      autoWidth: true,
      autoScroll: {
        speed: speed,
      },
    });

    updateClonesOnResize(splideInstance, itemWidth);

    splideInstance.mount({ AutoScroll });
  });
};

const slider = () => {
  setupCategorySlider();
  setupFirstViewSlider();
  setupKeywordSliders();
};

export default slider;
